module.exports = __webpack_public_path__ + "img/building.87153f49.svg";